// extracted by mini-css-extract-plugin
export default {"ImageTypeValue":"ImageTypeValueI9eWF","imageTypeValue":"ImageTypeValueI9eWF"};